<template>
  <div class="accent">
    <v-container fluid class="pa-3 pa-md-4">
      <team-menu />
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    teamMenu: () => import('@/components/team-managment/menu'),
  },
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    snackback: false,
  }),
}
</script>
